const Input = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  className = "",
  inputClassName = "",
  isRequired = false,
  onFocus,
  onBlur,
  disabled,
  isForm,
  name,
  error,
  maxLength
}) => {
  return (
    <>
      <div className={`flex flex-col ${className}`}>
        {label && (
          <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
            {label}
            {isRequired && (
              <span className="text-red-500 ml-1 font-bold">*</span>
            )}{" "}
          </label>
        )}
        <input
          type={type}
          onFocus={onFocus}
          maxLength={maxLength}
          onBlur={onBlur}
          value={value}
          name={name}
          onChange={(e) => {
            if (isForm) {
              onChange(e);
            } else {
              onChange(e.target.value);
            }
          }}
          disabled={disabled}
          placeholder={placeholder}
          style={{
            cursor: disabled ? "not-allowed" : "",
          }}
          className={`py-3 px-2 text-sm border-2 border-gray-300 rounded-lg outline-none focus:outline-none focus:ring-0 focus:border-[#2BACE2] focus-visible:outline-none ${inputClassName}`}
        />
      </div>
      {error && <div className="text-red-400 text-sm">{error}</div>}
    </>
  );
};

export default Input;
